export enum AccessRole {
  SUPER_ADMIN = 'SUPER_ADMIN',
  ADMIN = 'ADMIN',
  SALES = 'SALES',
  SUPPORT = 'SUPPORT',
  DEVELOPER = 'DEVELOPER',
  CMS_SUPERVISOR = 'CMS_SUPERVISOR',
  DEFAULT = 'DEFAULT',
}

export const ALL_ACCESS_ROLES: AccessRole[] = Object.values(AccessRole)
